/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

export const functionNames = [
  'ABS',
  'ABSENT',
  'ABSENT_OVER_TIME',
  'ACOS',
  'ACOSH',
  'ASIN',
  'ASINH',
  'ATAN',
  'ATAN2',
  'ATANH',
  'AVG',
  'AVG_OVER_TIME',
  'BIT_LENGTH',
  'BUCKET',
  'BYTE_LENGTH',
  'CASE',
  'CATEGORIZE',
  'CBRT',
  'CEIL',
  'CHUNK',
  'CIDR_MATCH',
  'CLAMP',
  'CLAMP_MAX',
  'CLAMP_MIN',
  'COALESCE',
  'CONCAT',
  'CONTAINS',
  'COPY_SIGN',
  'COS',
  'COSH',
  'COUNT_DISTINCT',
  'COUNT_DISTINCT_OVER_TIME',
  'COUNT_OVER_TIME',
  'COUNT',
  'DATE_DIFF',
  'DATE_EXTRACT',
  'DATE_FORMAT',
  'DATE_PARSE',
  'DATE_TRUNC',
  'DATE_UNIT_COUNT',
  'DAY_NAME',
  'DECAY',
  'DELTA',
  'DERIV',
  'E',
  'EARLIEST',
  'EMBEDDING',
  'ENDS_WITH',
  'EXP',
  'FIELD_EXTRACT',
  'FIRST',
  'FIRST_OVER_TIME',
  'FLOOR',
  'FROM_BASE64',
  'GREATEST',
  'HASH',
  'HYPOT',
  'IDELTA',
  'INCREASE',
  'IP_PREFIX',
  'IRATE',
  'JSON_EXTRACT',
  'KNN',
  'KQL',
  'LAST',
  'LAST_OVER_TIME',
  'LATEST',
  'LEAST',
  'LEFT',
  'LENGTH',
  'LOCATE',
  'LOG',
  'LOG10',
  'LTRIM',
  'MATCH',
  'MATCH_PHRASE',
  'MAX',
  'MAX_OVER_TIME',
  'MD5',
  'MEDIAN_ABSOLUTE_DEVIATION',
  'MEDIAN',
  'MIN',
  'MIN_OVER_TIME',
  'MONTH_NAME',
  'MV_APPEND',
  'MV_AVG',
  'MV_CONCAT',
  'MV_CONTAINS',
  'MV_COUNT',
  'MV_DEDUPE',
  'MV_DIFFERENCE',
  'MV_FIRST',
  'MV_INTERSECTION',
  'MV_INTERSECTS',
  'MV_IN_RANGE',
  'MV_LAST',
  'MV_LIKE',
  'MV_MAX',
  'MV_MEDIAN_ABSOLUTE_DEVIATION',
  'MV_MEDIAN',
  'MV_MIN',
  'MV_PERCENTILE',
  'MV_PSERIES_WEIGHTED_SUM',
  'MV_RLIKE',
  'MV_SLICE',
  'MV_SORT',
  'MV_SUM',
  'MV_UNION',
  'MV_ZIP',
  'NETWORK_DIRECTION',
  'NOW',
  'PERCENTILE',
  'PERCENTILE_OVER_TIME',
  'PI',
  'POW',
  'PRESENT',
  'PRESENT_OVER_TIME',
  'QSTR',
  'RANGE_CONTAINS',
  'RANGE_INTERSECTS',
  'RANGE_MAX',
  'RANGE_MIN',
  'RANGE_WITHIN',
  'RATE',
  'REPEAT',
  'REPLACE',
  'REVERSE',
  'RIGHT',
  'ROUND',
  'ROUND_TO',
  'RTRIM',
  'SAMPLE',
  'SCALB',
  'SCORE',
  'SHA1',
  'SHA256',
  'SIGNUM',
  'SIN',
  'SINH',
  'SPACE',
  'SPARKLINE',
  'SPLIT',
  'SQRT',
  'ST_BUFFER',
  'ST_CENTROID_AGG',
  'ST_CONTAINS',
  'ST_DIFFERENCE',
  'ST_DIMENSION',
  'ST_DISJOINT',
  'ST_DISTANCE',
  'ST_ENVELOPE',
  'ST_EXTENT_AGG',
  'ST_GEOHASH',
  'ST_GEOHEX',
  'ST_GEOMETRYTYPE',
  'ST_GEOTILE',
  'ST_INTERSECTION',
  'ST_INTERSECTS',
  'ST_ISEMPTY',
  'ST_NPOINTS',
  'ST_SIMPLIFY',
  'ST_SIMPLIFYPRESERVETOPOLOGY',
  'ST_SYMDIFFERENCE',
  'ST_UNION',
  'ST_WITHIN',
  'ST_X',
  'ST_XMAX',
  'ST_XMIN',
  'ST_Y',
  'ST_YMAX',
  'ST_YMIN',
  'STARTS_WITH',
  'STD_DEV',
  'STDDEV_OVER_TIME',
  'SUBSTRING',
  'SUM',
  'SUM_OVER_TIME',
  'TAN',
  'TANH',
  'TAU',
  'TBUCKET',
  'TEXT_EMBEDDING',
  'TO_AGGREGATE_METRIC_DOUBLE',
  'TO_BASE64',
  'TO_BOOLEAN',
  'TO_CARTESIANPOINT',
  'TO_CARTESIANSHAPE',
  'TO_COUNTER',
  'TO_DATE_NANOS',
  'TO_DATEPERIOD',
  'TO_DATETIME',
  'TO_DATE_RANGE',
  'TO_DEGREES',
  'TO_DENSE_VECTOR',
  'TO_DOUBLE',
  'TO_DOUBLE_RANGE',
  'TO_EXPONENTIAL_HISTOGRAM',
  'TO_GAUGE',
  'TO_GEOHASH',
  'TO_GEOHEX',
  'TO_GEOPOINT',
  'TO_GEOSHAPE',
  'TO_GEOTILE',
  'TO_INTEGER',
  'TO_IP',
  'TO_LONG',
  'TO_LOWER',
  'TO_RADIANS',
  'TO_RANGE',
  'TO_STRING',
  'TO_TDIGEST',
  'TO_TEXT',
  'TO_TIMEDURATION',
  'TO_UNSIGNED_LONG',
  'TO_UPPER',
  'TO_VERSION',
  'TOP',
  'TOP_SNIPPETS',
  'TRANGE',
  'TRIM',
  'TSTEP',
  'URL_DECODE',
  'URL_ENCODE',
  'URL_ENCODE_COMPONENT',
  'V_COSINE',
  'V_DOT_PRODUCT',
  'V_HAMMING',
  'V_L1_NORM',
  'V_L2_NORM',
  'V_MAGNITUDE',
  'VALUES',
  'VARIANCE',
  'VARIANCE_OVER_TIME',
  'WEIGHTED_AVG',
  'WITHOUT',
  'ADD',
  'CAST',
  'DIV',
  'EQUALS',
  'GREATER_THAN',
  'GREATER_THAN_OR_EQUAL',
  'IN',
  'IS_NOT_NULL',
  'IS_NULL',
  'LESS_THAN',
  'LESS_THAN_OR_EQUAL',
  'LIKE',
  'MATCH_OPERATOR',
  'MOD',
  'MUL',
  'NEG',
  'NOT_IN',
  'NOT_LIKE',
  'NOT_RLIKE',
  'NOT_EQUALS',
  'RLIKE',
  'SUB',

  // -------------------------------------------------------- special functions
  'DELAY', // Gated for Elasticsearch internal use
  'CHICKEN', // Easter-egg
];
